<!-- MAIN (Center website) -->

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<div class="header">
  <div class="logo header-content"></div>
  <ul class="user-actions header-content">
    <li><a routerLink="/login">Sign in </a></li>

  </ul>
</div>
<div class="nav">
  <ul class="nav-options">
    <li>Our Product</li>
    <li>Plans</li>
    <li>Help</li>
    <li>Contact</li>
  </ul>
</div>
<div class="page-container">
  <h1>Let's first create an Admin Profile</h1>

  <div class="container">
    <form #userForm="ngForm">

      <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="user.first_name" name="first_name"
        #first_name="ngModel" class="form-control" placeholder="First Name">
      <div class="alert" *ngIf="!first_name.valid"> <img src="assets/images/icon-alert.png">
        First name is required & should be alpahbets only</div>

      <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="user.last_name" name="last_name"
        #last_name="ngModel" class="form-control" placeholder="Last Name">
      <div class="alert alert-danger" *ngIf="!last_name.valid"> <img src="assets/images/icon-alert.png">
        Last name is required & should be alpahbets only</div>

      <input type="text" maxlength='12' pattern="[0-9\s]+" required [(ngModel)]=user.contact_no name="contact_no"
        #contact_no="ngModel" class="form-control" placeholder="Contact number" min="0" minlength="10" maxlength="10">
      <div class="alert" *ngIf="!contact_no.valid"> <img src="assets/images/icon-alert.png">
        This must be a valid number & it's required</div>


      <!-- pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"  -->
      <input id="email_id" on-focusout="checkEid()" [pattern]="emailpat" type="text" required
        [(ngModel)]="user.email_id" name="email_id" #email_id="ngModel" class="form-control"
        placeholder="Your Email-Id (Active)">
      <div class="alert" *ngIf="!email_id.valid">
        <img src="assets/images/icon-alert.png"> Enter a valid Email-id for which account activation link will be sent
      </div>
      <div [innerHTML]="innerHtml"> </div>

      <input ng required type="password" [(ngModel)]=user.password0 name="password0" #password0="ngModel"
        class="form-control" placeholder="Password">
      <div class="alert alert-danger" *ngIf="!password.valid">
        <img src="assets/images/icon-alert.png">
        Confirm Password
      </div>

      <input type="password" required [(ngModel)]=user.password #password="ngModel" name="password" class="form-control"
        placeholder="Confirm Password">
      <div class="alert alert-danger" *ngIf="userForm.value.password !== userForm.value.password0 ">
        <img src="assets/images/icon-alert.png">
        Password mismatch
      </div>
      <br>


      <button type="button" [disabled]="!userForm.valid || innerHtml" (click)="save()" class="btn primary-btn"
        name="submit">Continue</button>

    </form>
  </div>
</div>